//styling
import './App.css';
import 'typeface-lato';

import { BrowserRouter, Route, Routes} from 'react-router-dom';

//components
import NavbarComponent from '../components/navbar.js';

//pages
import Home from '../pages/home.js';
import About from '../pages/about.js';
import Contact from '../pages/contact.js';
import TermsAndServices from '../pages/terms-and-services.js';
import NoPage from '../pages/no-page.js';
import HowToPlay from '../pages/how-to-play.js';
import Redeem from '../pages/redeem.js';
import PrivacyPolicy from '../pages/privacy-policy.js';


function App() {
  return (
    <div style={{backgroundColor: "#FFFBF3"}}>
      <div>
        <BrowserRouter>
          <NavbarComponent />
          <Routes>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/how-to-play" element={<HowToPlay />} />
            <Route path="/redeem" element={<Redeem />} />
            <Route path="/terms-and-services" element={<TermsAndServices />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NoPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
